import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';


class FineReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All user wise issued return resource report List
            fineReportListLoading: false,
            FineReportListData: {},
            totalDataItem: 0,
            pageIndex: 1,
            limit: "10",

            // filter field values
            // new Date().toISOString().split('T')[0]
            returnStartDate: "",
            returnEndDate: "",
            userRole: '',
            searchByAcademicYear: '',
            searchByDepartment: '',
            searchByProgram: '',
            searchBySemester: '',

            academicYearSequence: [],  // academic year data
            academicYearList: [],
            academicYearArray: {},

            GetStreamList: {},  // department data
            loadingStreamData: false,

            programListArray: {},  // program data
            loadingProgramData: false,

            semesterListArray: {},  // semester data
            loadingStreamGroupData: false,

            loadingStudentData: false,
            studentListData: [],

            //filter button 
            showFilterModal: false,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Date", isVisible: true },
                { name: 'User Name', isVisible: true },
                { name: 'Default Department', isVisible: true },
                { name: 'User ID', isVisible: true },
                { name: "Return By", isVisible: true },
                { name: "Role", isVisible: true },
                { name: "Type", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author / Publisher", isVisible: true },
                { name: "Accession No.", isVisible: true },
                { name: "Receipt Number", isVisible: true },
                { name: "Collected Fine", isVisible: true },
                { name: "Applicable Fine", isVisible: true },
                { name: "Waived Fine", isVisible: true },
                { name: "Balance Fine", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { label: "Date", key: 'date' },
                { label: 'User Name', key: 'userName' },
                { label: 'Default Department', key: 'department' },
                { label: 'User ID', key: 'userId' },
                { label: "Return By", key: 'returnBy' },
                { label: "Role", key: 'role' },
                { label: "Type", key: 'type' },
                { label: "Title", key: 'title' },
                { label: "Author / Publisher", key: 'author' },
                { label: "Accession No.", key: 'accessionNo' },
                { label: "Receipt Number", key: 'ReceiptNo' },
                { label: "Collected Fine", key: 'collectedFine' },
                { label: "Applicable Fine", key: 'applicableFine' },
                { label: "Waived Fine", key: 'waivedFine' },
                { label: "Balance Fine", key: 'balanceFine' }
            ],

            exportItemVisibility: [
                { name: "Date", isVisible: true },
                { name: 'User Name', isVisible: true },
                { name: 'Default Department', isVisible: true },
                { name: 'User ID', isVisible: true },
                { name: "Return By", isVisible: true },
                { name: "Role", isVisible: true },
                { name: "Type", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author / Publisher", isVisible: true },
                { name: "Accession No.", isVisible: true },
                { name: "Receipt Number", isVisible: true },
                { name: "Collected Fine", isVisible: true },
                { name: "Applicable Fine", isVisible: true },
                { name: "Waived Fine", isVisible: true },
                { name: "Balance Fine", isVisible: true }
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: [],
            allSortedIdArray: [],
            sortedIdArray: [],

            // total count
            collectedFineCount: 0,
            applicableFineCount: 0,
        };
    }

    componentDidMount() {
        this.GetFineReportList(); // report list
        this.formatCSVExportData('onLoad');
    }

    // API CALL TO GET get fine report List
    GetFineReportList = async () => {
        this.setState({
            fineReportListLoading: true,
        })

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "status": "returned",
            "isOnlyFineUser": "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAllIssuedResourceListForReport',
            requestData,
            "/api/library/instructor.php"
        );


        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetFineReportList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                // Use reduce to accumulate totals
                const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                    const keyCollectedFine = resource.collected_fine || 0;
                    const keyApplicableFine = resource.fine_amount || 0;

                    // Accumulate totals
                    accumulator.totalCollectedFine += parseInt(keyCollectedFine);
                    accumulator.totalApplicableFine += (parseInt(keyApplicableFine));
                    return accumulator;
                }, {
                    totalCollectedFine: 0,
                    totalApplicableFine: 0,
                });

                this.setState({
                    FineReportListData: apiResult.data,
                    totalDataItem: apiResult.totalRecords,
                    collectedFineCount: totals.totalCollectedFine,
                    applicableFineCount: totals.totalApplicableFine,
                    fineReportListLoading: false,
                })
            } else {
                this.setState({
                    FineReportListData: {},
                    totalDataItem: 0,
                    collectedFineCount: 0,
                    applicableFineCount: 0,
                    fineReportListLoading: false,
                })
            }
        }
    }

    GetAllIssuedFilterResourceListForReport = async () => {
        this.setState({
            fineReportListLoading: true,
        })

        let filterParameter = {
            "startDate": this.state.returnStartDate,
            "endDate": this.state.returnEndDate,
            // "user_role": this.state.userRole
            "user_roleForFineReport": this.state.userRole

        }

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "filterParameter": filterParameter,
            "status": "returned",
            "isOnlyFineUser": "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAllIssuedFilterResourceListForReport',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetFineReportList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                // Use reduce to accumulate totals
                const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                    const keyCollectedFine = resource.collected_fine || 0;
                    const keyApplicableFine = resource.fine_amount || 0;

                    // Accumulate totals
                    accumulator.totalCollectedFine += parseInt(keyCollectedFine);
                    accumulator.totalApplicableFine += (parseInt(keyApplicableFine));
                    return accumulator;
                }, {
                    totalCollectedFine: 0,
                    totalApplicableFine: 0,
                });

                this.setState({
                    FineReportListData: apiResult.data,
                    totalDataItem: apiResult.totalRecords,
                    collectedFineCount: totals.totalCollectedFine,
                    applicableFineCount: totals.totalApplicableFine,
                    fineReportListLoading: false,
                })
            } else {
                this.setState({
                    FineReportListData: {},
                    totalDataItem: 0,
                    collectedFineCount: 0,
                    applicableFineCount: 0,
                    fineReportListLoading: false,
                })
            }
        }
    }

    // METHOD TO GET ACADEMIC YEAR LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                // Map the apiData to the desired format
                const formattedData = Object.keys(apiResult).map(key => ({
                    yearID: key,
                    yearName: apiResult[key].year_text
                }));

                this.setState({
                    academicYearArray: formattedData,
                    academicYearList: apiResult,
                    academicYearSequence: jsonResponse.APIResult.sortedIdArray,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting academic year list. Please try again later.'
                });
            }
        }
    }

    // API CALL TO GET get Institute departments List
    GetInstituteDepartment = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "delete_status": "active"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteDepartment',
            requestData,
            "/api/settings/instituteDepartments.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteDepartment();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.data,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET get departments program List
    GetInstituteStreamsObject = async () => {
        this.setState({
            loadingProgramData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "departmentForFilter": this.state.searchByDepartment,
            "showParentGroupData": true,
            "sidArray": []
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    programListArray: apiResult.data,
                    loadingProgramData: false,
                })
            } else {
                this.setState({
                    loadingProgramData: false,
                })
            }
        }
    }

    // API CALL TO GET get stream group (semester) data
    getSemesterListData = async () => {
        this.setState({
            loadingStreamGroupData: true,
        })
        let requestData = {
            "acayr": this.state.searchByAcademicYear,
            "sid": this.state.searchByProgram
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getStreamGroupList',
            requestData,
            "/api/fees/fees.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getSemesterListData();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    semesterListArray: apiResult.streamGroupList,
                    loadingStreamGroupData: false,
                })
            } else {
                this.setState({
                    loadingStreamGroupData: false,
                })
            }
        }
    }

    // filter academic year on change
    handleFilterAcdyearChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAcademicYear: event.target.value, }
            , () => {
                this.getSemesterListData();  // semester
            }
        );
    };

    // filter department on change
    handleDepartmentChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByDepartment: event.target.value, searchBySemester: '', searchByProgram: '' }
            , () => {
                this.GetInstituteStreamsObject();  // program
            }
        );
    };

    // filter program on change
    handleProgramChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByProgram: event.target.value }
            , () => {
                this.getSemesterListData();  // semester
            }
        );
    };

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        if (this.state.returnStartDate != "" || this.state.returnEndDate != "" || this.state.userRole != '' || this.state.searchByAcademicYear != '' || this.state.searchByDepartment != '' || this.state.searchByProgram != '' || this.state.searchBySemester != '') {
            this.setState({ pageIndex: pageNumber, returnStartDate: this.state.returnStartDate, returnEndDate: this.state.returnEndDate, userRole: this.state.userRole, searchByAcademicYear: this.state.searchByAcademicYear, searchByDepartment: this.state.searchByDepartment, searchByProgram: this.state.searchByProgram, searchBySemester: this.state.searchBySemester }, () => {
                this.GetAllIssuedFilterResourceListForReport();
            });
        } else {
            this.setState({ pageIndex: pageNumber, returnStartDate: this.state.returnStartDate, returnEndDate: this.state.returnEndDate, userRole: this.state.userRole, searchByAcademicYear: this.state.searchByAcademicYear, searchByDepartment: this.state.searchByDepartment, searchByProgram: this.state.searchByProgram, searchBySemester: this.state.searchBySemester }, () => {
                this.GetFineReportList();
            });
        }

    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        if (this.state.returnStartDate != "" || this.state.returnEndDate != "" || this.state.userRole != '' || this.state.searchByAcademicYear != '' || this.state.searchByDepartment != '' || this.state.searchByProgram != '' || this.state.searchBySemester != '') {
            this.setState({ pageIndex: 1, limit: event.target.value, returnStartDate: this.state.returnStartDate, returnEndDate: this.state.returnEndDate, userRole: this.state.userRole, searchByAcademicYear: this.state.searchByAcademicYear, searchByDepartment: this.state.searchByDepartment, searchByProgram: this.state.searchByProgram, searchBySemester: this.state.searchBySemester }, () => {
                this.GetAllIssuedFilterResourceListForReport();
            });
        } else {
            this.setState({ pageIndex: 1, limit: event.target.value, returnStartDate: this.state.returnStartDate, returnEndDate: this.state.returnEndDate, userRole: this.state.userRole, searchByAcademicYear: this.state.searchByAcademicYear, searchByDepartment: this.state.searchByDepartment, searchByProgram: this.state.searchByProgram, searchBySemester: this.state.searchBySemester }, () => {
                this.GetFineReportList();
            });
        }
    }

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            returnStartDate: "", returnEndDate: "", userRole: '',
            searchByAcademicYear: '', searchByDepartment: '', searchByProgram: '', searchBySemester: '',
        }, () => {
            this.GetFineReportList();
        }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterUserType = this.state.userRole
        let filterReturnStartDate = this.state.returnStartDate
        let filterReturnEndDate = this.state.returnEndDate

        if (filterUserType) {
            FilterArray.push(`User Role - ${filterUserType}`)
        }
        if (filterReturnStartDate) {
            FilterArray.push(`Return Start Date - ${filterReturnStartDate}`)
        }
        if (filterReturnEndDate) {
            FilterArray.push(`Return End Date - ${filterReturnEndDate}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllFineReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                Fine Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Date</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>User Name</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Default Department</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>User ID</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Return By</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Role</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Role</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Author / Publisher</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Accession No.</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Receipt Number</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Collected Fine</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Applicable Fine</th>}
                        {this.state.exportItemVisibilityForRows[13].isVisible && <th>Waived Fine</th>}
                        {this.state.exportItemVisibilityForRows[14].isVisible && <th>Balance Fine</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="12">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((userData, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{userData?.issued_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{userData?.user_name || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{userData?.defaultDepartmentName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{userData?.user_id || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{userData?.returnBy || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{userData?.user_role || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{userData?.resourcePeriodicalType.charAt(0).toUpperCase() + userData?.resourcePeriodicalType.slice(1) || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{userData?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{userData?.author || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{userData?.accession_Series_number || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{userData?.transaction_id || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{userData?.collected_fine || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{userData?.fine_amount || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[13].isVisible && <td>{userData?.waived_fine_amount || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[14].isVisible && <td>{(userData?.fine_amount - userData?.collected_fine - userData?.waived_fine_amount) || 0}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="12">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalDataItem } = this.state;
        const totalPages = Math.ceil(totalDataItem / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let jsonResponse;

            let requestData = {
                "iid": config.institute_id,
                "pageIndex": pageIndex,
                "limitPerPage": 50,
                "status": "returned",
                "isOnlyFineUser": "true"
            }

            let filterParameter = {
                "startDate": this.state.returnStartDate,
                "endDate": this.state.returnEndDate,
                // "user_role": this.state.userRole
                "user_roleForFineReport": this.state.userRole
            }

            let requestDataFilter = {
                "iid": config.institute_id,
                "pageIndex": pageIndex,
                "limitPerPage": 50,
                "filterParameter": filterParameter,
                "status": "returned",
                "isOnlyFineUser": "true"
            }

            {
                this.state.returnStartDate != "" || this.state.returnEndDate != "" || this.state.userRole != '' || this.state.searchByAcademicYear != '' || this.state.searchByDepartment != '' || this.state.searchByProgram != '' || this.state.searchBySemester != '' ?

                    jsonResponse = await LibraryApiCall.makeApiCall(
                        'GetAllIssuedFilterResourceListForReport',
                        requestDataFilter,
                        '/api/library/instructor.php'
                    ) : jsonResponse = await LibraryApiCall.makeApiCall(
                        'GetAllIssuedResourceListForReport',
                        requestData,
                        '/api/library/instructor.php'
                    )
            }


            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let Data = [];
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    sortedResponseArrayFromApi.map((uid) => {
                        Data.push(apiResult[uid]);
                    });

                    // Concatenate new data and update state
                    this.setState((prevState) => ({
                        allReportData: [
                            ...prevState.allReportData,
                            ...Data,
                        ],
                    }), () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });

                    // this.setState({
                    //     allReportData: { ...allReportData, ...apiResult },
                    //     allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                    //     totalRecords: jsonResponse.APIResult.totalRecords,
                    // }, () => {

                    //     // Fetch the next page recursively
                    //     this.methodToExportReportData(pageIndex);
                    // });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterUserType = this.state.userRole
        let filterReturnStartDate = this.state.returnStartDate
        let filterReturnEndDate = this.state.returnEndDate

        if (filterUserType) {
            FilterArray.push(`User Role - ${filterUserType}`)
        }
        if (filterReturnStartDate) {
            FilterArray.push(`Return Start Date - ${filterReturnStartDate}`)
        }
        if (filterReturnEndDate) {
            FilterArray.push(`Return End Date - ${filterReturnEndDate}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        {/* header */}
                        <div className="d-flex col-md-12 px-0">
                            <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                {/* action button - filter */}
                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                    {/* Based On Search by user role */}
                                    <div className="mb-2  p-1">
                                        <label className="vm_custom_body3" color='#454E52'>Role</label>
                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                            <select
                                                className="form-control formControlContentTask"
                                                style={{
                                                    // width: 'auto',
                                                    width: '165px',
                                                    height: '42px',
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    lineHeight: '20px',
                                                    fontFamily: "'Poppins', sans-serif",
                                                    color: '#808080',
                                                    borderRadius: '7px'
                                                }}
                                                id="searchByProgramFilter"
                                                onChange={(e) => {
                                                    this.setState({
                                                        userRole: e.target.value
                                                    }, () => {
                                                        this.GetAllIssuedFilterResourceListForReport();  // Call the API to fetch data
                                                        // Check if there's a valid selection
                                                        // if (e.target.value == 'faculty') {
                                                        //     this.GetAllIssuedFilterResourceListForReport();  // Call the API to fetch data
                                                        // } else {
                                                        //     this.apiCallToGetAcademicYearList();
                                                        //     this.GetInstituteDepartment();
                                                        // }
                                                    })
                                                }} // Attach handler here
                                                value={this.state.userRole} // Bind dropdown value to state
                                            >
                                                <option value="">Select User Role</option>
                                                <option value="faculty">Faculty</option>
                                                <option value="student">Student</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* Based On Search by return from date */}
                                    <div className="mb-2  p-1">
                                        <label className="vm_custom_body3" color='#454E52'>Return Start Date</label>
                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                            <input
                                                type="date"
                                                className="form-control"
                                                style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                placeholder="Select Return Start Date"
                                                value={this.state.returnStartDate}
                                                onChange={(event) => {
                                                    this.setState({
                                                        returnStartDate: event.target.value || '', // Handle empty selection
                                                    }, () => {
                                                        this.GetAllIssuedFilterResourceListForReport()
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Based On Search by return to date */}
                                    <div className="mb-2  p-1">
                                        <label className="vm_custom_body3" color='#454E52'>Return End Date</label>
                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                            <input
                                                type="date"
                                                className="form-control"
                                                style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                placeholder="Select Return End Date"
                                                value={this.state.returnEndDate}
                                                onChange={(event) => {
                                                    this.setState({
                                                        returnEndDate: event.target.value || '', // Handle empty selection
                                                    }, () => {
                                                        this.GetAllIssuedFilterResourceListForReport()
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                Object.keys(this.state.FineReportListData).length == 0 ? null :
                                    <div className="col-md-6 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex align-items-center">
                                            {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="fineReportTable"
                                                            filename="FineReportData"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="exportAll"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="ExportAllFineReport"   // export all functionality
                                                            filename="ExportAllFineReportData"
                                                            sheet="tablexls"
                                                            buttonText="Export All to Excel"
                                                        />
                                                    </div>
                                                    <button
                                                        onClick={this.formatCSVExportData}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                    {this.state.isExportAllReportDataFetching ? (
                                                        <p className="dropdown-item">
                                                            Exporting report . . .&nbsp;
                                                            <FontAwesomeIcon
                                                                icon={["fas", "circle-notch"]}
                                                                className="rotate"
                                                            />
                                                        </p>
                                                    ) : (
                                                        <button
                                                            onClick={() => this.setState({ allReportData: [] }, () => {
                                                                this.methodToExportReportData(0)
                                                            })}
                                                            className="dropdown-item"
                                                            title="Click to Export All"
                                                            style={{ boxShadow: 'none' }}
                                                        >
                                                            Export All
                                                        </button>
                                                    )}
                                                </span>

                                            </div>

                                        </div>

                                        {/* 2 action button - print */}
                                        <div className="d-flex ml-2" title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* 3 action button - column visibility */}
                                        <div className="d-flex ml-2" title="Click to Customize Columns">
                                            <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />

                                            {/* action modal - column visibility*/}
                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                {/* id='settingDropdown' */}
                                                <div className='settingDropdown-body'>
                                                    {
                                                        this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                            return (
                                                                <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                    <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                    <input type="checkbox" checked={columnInfo.isVisible} />
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>

                        {/* filter fields */}
                        <div>
                            {/* In Discussion */}
                            {this.state.userRole == "TODO" ?
                                // User Type : student
                                <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}>
                                    <div style={{ width: '100%' }}>
                                        {/* filter data form*/}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                            <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                {/* Based on academic year */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Academic Year</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByProgramFilter"
                                                            onChange={this.handleFilterAcdyearChange} // Attach handler here
                                                            value={this.state.searchByAcademicYear} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Academic Year</option>
                                                            {
                                                                Object.keys(this.state.academicYearList).length > 0 &&
                                                                this.state.academicYearSequence.map(yearId => {
                                                                    let year = this.state.academicYearList[yearId];
                                                                    return (
                                                                        <option value={yearId} key={yearId}>{year.year_text}</option>
                                                                    );
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on department */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Department</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleDepartmentChange} // Attach handler here
                                                            value={this.state.searchByDepartment} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Department</option>
                                                            {Object.values(this.state.GetStreamList).map((stream) => (
                                                                <option key={stream?.unique_id} value={stream?.unique_id} title={stream?.department_name} >
                                                                    {stream?.department_name?.length > 30 ? `${stream?.department_name.substring(0, 10)}...` : stream?.department_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on program */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Program</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleProgramChange} // Attach handler here
                                                            value={this.state.searchByProgram} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Program</option>
                                                            {Object.entries(this.state.programListArray).map(([id, stream]) => (
                                                                <option key={id} value={id} title={stream?.stream_name}>
                                                                    {stream?.stream_name?.length > 30 ? `${stream?.stream_name.substring(0, 30)}...` : stream?.stream_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on semester */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Semester</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchBySemester"
                                                            onChange={this.handleFilterSemesterChange} // Attach handler here
                                                            value={this.state.searchBySemester} // Bind dropdown value to state
                                                        >
                                                            {/* Check if both program and Academic Year are selected */}
                                                            {this.state.searchByAcademicYear && this.state.searchByProgram ? (
                                                                <>
                                                                    <option value="">Select Semester</option>
                                                                    {Object.values(this.state.semesterListArray).length > 0 ? (
                                                                        Object.values(this.state.semesterListArray).map((stream) => (
                                                                            <option key={stream?.id} value={stream?.id} title={stream?.title}>
                                                                                {stream?.title?.length > 30 ? `${stream?.title.substring(0, 30)}...` : stream?.title}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="" disabled>No data found</option>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <option value="" disabled>
                                                                    Select program & academic year to get semester
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }

                            {
                                (this.state.returnStartDate != "" || this.state.returnEndDate != "" || this.state.userRole != '' || this.state.searchByAcademicYear != '' || this.state.searchByDepartment != '' || this.state.searchByProgram != '' || this.state.searchBySemester != '') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Fine Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="fineReportTable">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" style={{ textAlign: 'center' }}>
                                                        Fine Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Date</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>User Name</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Default Department</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>User ID</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Return By</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Role</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Type</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Author / Publisher</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Accession No.</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Receipt Number</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Collected Fine</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Applicable Fine</th>}
                                                {this.state.exportItemVisibilityForRows[13].isVisible && <th>Waived Fine</th>}
                                                {this.state.exportItemVisibilityForRows[14].isVisible && <th>Balance Fine</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.fineReportListLoading ? <tr>
                                                    <td colSpan="11">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                    Object.keys(this.state.FineReportListData).length > 0 ?
                                                        (Object.values(this.state.FineReportListData).map((userData, index) => (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                {this.state.exportItemVisibilityForRows[0].isVisible && <td>{userData?.issued_date || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[1].isVisible && <td>{userData?.user_name || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[2].isVisible && <td>{userData?.defaultDepartmentName || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[3].isVisible && <td>{userData?.user_id || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && <td>{userData?.returnBy || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[5].isVisible && <td>{userData?.user_role || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[6].isVisible && <td>{userData?.resourcePeriodicalType.charAt(0).toUpperCase() + userData?.resourcePeriodicalType.slice(1) || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[7].isVisible && <td>{userData?.title || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[8].isVisible && <td>{userData?.author || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[9].isVisible && <td>{userData?.accession_Series_number || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[10].isVisible && <td>{userData?.transaction_id || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[11].isVisible && <td>{userData?.collected_fine || 0}</td>}
                                                                {this.state.exportItemVisibilityForRows[12].isVisible && <td>{userData?.fine_amount || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[13].isVisible && <td>{userData?.waived_fine_amount || 0}</td>}
                                                                {this.state.exportItemVisibilityForRows[14].isVisible && <td>{(userData?.fine_amount - userData?.collected_fine - userData?.waived_fine_amount) || 0}</td>}
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="11">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                            {
                                                // display total count
                                                Object.keys(this.state.FineReportListData).length > 0 ?
                                                    this.state.fineReportListLoading ? null :
                                                        <>
                                                            <tr>
                                                                <td colSpan="1" style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                                                <td colSpan="11"></td>
                                                                {/* Sum of collected fine */}
                                                                {this.state.exportItemVisibilityForRows[10].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.collectedFineCount}
                                                                </td>}
                                                                {/* Sum of applicable fine */}
                                                                {this.state.exportItemVisibilityForRows[11].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.applicableFineCount}
                                                                </td>}
                                                            </tr>
                                                        </>
                                                    : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {
                                (Object.keys(this.state.FineReportListData).length > 0 || Object.keys(this.state.FineReportListData).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalDataItem}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalDataItem || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div >
                </div>
            </div >

        );
    }
}


export default FineReport;